import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../services/analyticsService';

export function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    analyticsService.trackPageView({
      page_path: location.pathname + location.search,
      page_title: document.title
    });
  }, [location]);

  return {
    trackEvent: analyticsService.trackEvent.bind(analyticsService),
    trackConversion: analyticsService.trackConversion.bind(analyticsService),
    trackPerformance: analyticsService.trackPerformance.bind(analyticsService)
  };
}
